//This file contains generic functions and constants for local storage

const showDelinkedChildFlashMessage = () => {
  const hasDelinkedChild = localStorage.getItem(LocalStorageMap['hasDelinkedChild'])
    if(hasDelinkedChild){
      const studentName = localStorage.getItem(LocalStorageMap['studentName'])
      SPWidget.showFlashMessage(`${studentName}’s profile is removed!`, 'success');
      localStorage.removeItem(LocalStorageMap['hasDelinkedChild'])
      localStorage.removeItem(LocalStorageMap['studentName'])
    }
};

const LocalStorageMap = {
  'hasDelinkedChild': 'HAS_DELINKED_CHILD',
  'studentName': 'STUDENT_NAME'
}


export {
  showDelinkedChildFlashMessage as ShowDelinkedChildFlashMessage,
  LocalStorageMap
};